// FacilitatorsMenuItems.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { UilBriefcase } from '@iconscout/react-unicons';
import { useTranslation } from 'react-i18next';

export const getFacilitatorsMenuItems = (basePath, toggleCollapsed, topMenu) => {
  const { t } = useTranslation();
  return [
    {
      key: 'facilitators',
      label: t('Facilitators'),
      icon: !topMenu && <UilBriefcase size={20} />,
      children: [
        {
          key: 'facilitators-add',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator/register`}>
              {t('Add Facilitator')}
            </NavLink>
          ),
        },
        {
          key: 'facilitators-list',
          label: (
            <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator/list`}>
              {t('Facilitators List')}
            </NavLink>
          ),
        },
      ],
    },
    // {
    //   key: 'facilitator-validations',
    //   label: t('Project Validations'),
    //   icon: !topMenu && <UilUsersAlt size={20} />,
    //   children: [
    //     {
    //       key: 'validation-add',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator-teams/add`}>
    //           {t('Create Validation')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'validation-list',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator-teams/list`}>
    //           {t('Teams List')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'team-assignments',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator-teams/assignments`}>
    //           {t('Team Assignments')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
    // {
    //   key: 'facilitator-reports',
    //   label: t('Reports'),
    //   icon: !topMenu && <UilFileAlt size={20} />,
    //   children: [
    //     {
    //       key: 'activity-reports',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator-reports/activity`}>
    //           {t('Activity Reports')}
    //         </NavLink>
    //       ),
    //     },
    //     {
    //       key: 'performance-reports',
    //       label: (
    //         <NavLink onClick={toggleCollapsed} to={`${basePath}/facilitator-reports/performance`}>
    //           {t('Performance Reports')}
    //         </NavLink>
    //       ),
    //     },
    //   ],
    // },
  ];
};
